import { mountPrivacyReminder } from 'mk2/apps/blogs/miniapps';

export function initStatic(conf) {
    const placeholder = conf.node;
    const key = '0';
    const currentUrl = conf.currentUrl;
    mountPrivacyReminder(placeholder, key, currentUrl);
}
